import { Store } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { useLanguage } from "@/contexts/LanguageContext";
import { useIsMobile } from "@/hooks/use-mobile";
import { useScrollToTop } from "@/hooks/useScrollToTop";
import { useIsSeller } from "@/hooks/useIsSeller";
import { useScrollDirection } from "@/hooks/useScrollDirection";
import { useTranslation } from "react-i18next";

export function MobileTopBar() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { language, setLanguage } = useLanguage();
  const { t } = useTranslation('common');
  const { isSeller } = useIsSeller();
  const isMobile = useIsMobile();
  const handleScrollToTop = useScrollToTop();
  const { scrollDirection } = useScrollDirection();

  // Only show on mobile
  if (!isMobile) return null;

  const handleSellerClick = () => {
    if (isSeller) {
      handleScrollToTop("/seller-dashboard");
    } else if (user) {
      handleScrollToTop("/become-seller");
    } else {
      handleScrollToTop("/auth");
    }
  };

  return (
    <div
      className={`fixed top-0 left-0 right-0 z-50 bg-background/95 backdrop-blur border-b border-border transition-transform duration-150 ease-out ${
        scrollDirection === "down" ? "-translate-y-full" : "translate-y-0"
      }`}
    >
      <div className="flex items-center justify-between px-4 h-12">
        {/* Language Switcher */}
        <div className="flex items-center gap-1">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setLanguage('gr')}
            className={`h-8 px-3 text-xs font-medium ${language === 'gr' ? 'text-primary' : ''}`}
          >
            GR
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setLanguage('en')}
            className={`h-8 px-3 text-xs font-medium ${language === 'en' ? 'text-primary' : ''}`}
          >
            EN
          </Button>
        </div>

        {/* Seller Dashboard/Become Seller */}
        <Button
          variant="ghost"
          size="sm"
          onClick={handleSellerClick}
          className="h-8 px-3 text-xs font-medium"
          title={isSeller ? t('navigation.sellerDashboard') : t('navigation.becomeSeller')}
        >
          <Store className="h-4 w-4 mr-1" />
          {isSeller ? t('navigation.sellerDashboard') : t('navigation.sell')}
        </Button>
      </div>
    </div>
  );
}